import React, {FC} from 'react';
import brandLogo from "../../../../assets/media/brands/logo.svg";
import {useHistory} from "react-router-dom";
import {Form} from 'antd';

interface SuccessForgotPasswordProps {
}

const SuccessForgotPassword: FC<SuccessForgotPasswordProps> = () => {
    const history = useHistory();

    const handleBack = () => {
        history.push('/auth/login')
    }
    return (
        <>
            <div className="d-flex w-100 align-items-center position-relative overflow-hidden login-background-sub">
                <div className="login-wrapper">
                    <div className="login-title h1 b mb-32">
                        <img src={brandLogo} width="200" alt=""/>
                    </div>
                    <div className="box login-box">
                        <div className="form">
                            <div className="h2 font-weight-500 mb-4 text-center ff-fantasy">
                                VNPAY PORTAL INVOICE
                            </div>
                            <div
                                className="fz-h4 text-primary mb-4 text-center mt-10"
                            >
                                Quên mật khẩu
                            </div>
                            <div
                                className="fz-h4 mb-4 text-center"
                            >
                                <div className="h3 font-weight-200 mb-4 text-center mt-10">
                                    Gửi yêu cầu thành công!
                                </div>
                                <div className="mt-10 mb-10"> Thông tin mật khẩu mới đã được gửi vào hòm thư đăng ký tài khoản. Vui lòng kiểm
                                    tra email và làm theo hướng dẫn.
                                </div>

                            </div>
                        </div>
                        <Form.Item className="mt-10">
                            <button onClick={handleBack} className="btn btn-primary btn-block btn-lg">
                                Quay lại
                            </button>
                        </Form.Item>
                    </div>
                </div>
            </div>

        </>
    )

}


export default SuccessForgotPassword;
